var TouchEventWrapper = /** @class */ (function () {
    function TouchEventWrapper(touchEvent) {
        this.touchEvent = touchEvent;
    }
    Object.defineProperty(TouchEventWrapper.prototype, "clientX", {
        get: function () {
            return this.touchEvent.touches[0].clientX;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(TouchEventWrapper.prototype, "clientY", {
        get: function () {
            return this.touchEvent.touches[0].clientY;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(TouchEventWrapper.prototype, "offsetX", {
        get: function () {
            var rect = this.boundingClientRect;
            return rect ? this.clientX - window.pageXOffset - rect.left : 0;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(TouchEventWrapper.prototype, "offsetY", {
        get: function () {
            var rect = this.boundingClientRect;
            return rect ? this.clientY - window.pageYOffset - rect.top : 0;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(TouchEventWrapper.prototype, "boundingClientRect", {
        get: function () {
            var target = this.touchEvent.target;
            return target instanceof HTMLElement ? target.getBoundingClientRect() : undefined;
        },
        enumerable: false,
        configurable: true
    });
    return TouchEventWrapper;
}());
export { TouchEventWrapper };
